import { observable, action, runInAction } from 'mobx';
import { exportFile } from '../utils/download';

export default class UIState {
  @observable websiteName = 'Data Platform';
  @observable isFetchingExport= false
  @action
  onChangeFetchingExport(url, params, filename){
    this.isFetchingExport=true
    exportFile(url, params, filename,(res)=>{
      runInAction(()=>{
        this.isFetchingExport=false
      })
    })
  }
}
